/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAiTelemetryIngestion extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAiTelemetryIngestion");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAiTelemetryIngestion.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAiTelemetryIngestion>): BackgroundJobPayloadForAiTelemetryIngestion {
        let obj = Object.assign(new BackgroundJobPayloadForAiTelemetryIngestion(), model);
        BackgroundJobPayloadForAiTelemetryIngestion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAiTelemetryIngestion>): BackgroundJobPayloadForAiTelemetryIngestion {
        if (!model) return null;
        return BackgroundJobPayloadForAiTelemetryIngestion.newInstance(<BackgroundJobPayloadForAiTelemetryIngestion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAiTelemetryIngestion) {
        if (!obj) return;

        models.BackgroundJobPayloadForAiTelemetryIngestion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAiTelemetryIngestion): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAiTelemetryIngestion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
    }

    /**
     * Target AI Service Account
     */
    service_account_id: string;

    /**
     * Start date of the telemetry window to ingest.
     */
    start_date: Date;

    /**
     * End date of the telemetry window to ingest.
     */
    end_date: Date;

}
